// Sorties musicales réelles de Papicoo (fichiers originaux fournis, extraits 30 s uniquement).
// Champs : { id, title, version, duration, durationLabel, cover, audio, excerptSeconds } — aucun prix, aucun achat.
const base = `${process.env.PUBLIC_URL || ""}/musique-assets`;

export const MUSIC_RELEASES = [
  {
    id: "ce-qu-on-ne-voit-pas",
    title: "Ce qu’on ne voit pas",
    durationLabel: "3:00",
    cover: `${base}/ce-qu-on-ne-voit-pas-cover.png`,
    audio: `${base}/ce-qu-on-ne-voit-pas-extrait.mp3`,
    excerptSeconds: 30,
  },
  {
    id: "reine-hip-hop",
    title: "Reine d’ici et d’ailleurs",
    version: "Hip-Hop",
    durationLabel: "4:09",
    cover: `${base}/reine-cover.png`,
    audio: `${base}/reine-hip-hop-extrait.mp3`,
    excerptSeconds: 30,
  },
  {
    id: "reine-dance-mbalax",
    title: "Reine d’ici et d’ailleurs",
    version: "Dance Mbalax",
    durationLabel: "4:27",
    cover: `${base}/reine-cover.png`,
    audio: `${base}/reine-dance-mbalax-extrait.mp3`,
    excerptSeconds: 30,
  },
];

export const MUSIC_HERO_COVER = `${base}/ce-qu-on-ne-voit-pas-cover.png`;
